/**
 * Base error class for SafRegistry operations
 */
export class SafRegistryError extends Error {
	public constructor(message: string, public readonly cause?: unknown) {
		super(message);
		this.name = this.constructor.name;
	}
}
